import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup,Validators } from '@angular/forms'; // Add FormBuilder and FormGroup
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mentorstudentrequest',
  templateUrl: './mentorstudentrequest.component.html',
  styleUrls: ['./mentorstudentrequest.component.scss']
})
export class MentorstudentrequestComponent implements OnInit {

  customers: any = [];
  dtOptions: DataTables.Settings = {};
  mentorcourse: FormGroup; // Add form group
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  zones: any = this.apiService.all_districts_zone;
  user_name: any = this.apiService.user_details.firstname;
  user_id: any = this.apiService.user_details.id;
  userDistrict: any = this.apiService.user_details.district;
  userConstituency: any = this.apiService.user_details.constituency;

  constructor(
    private apiService: ApiServiceService,
    private spinnerService: NgxSpinnerService,
    private fb: FormBuilder ,
    private router: Router,// Inject FormBuilder 
  ) { }

  ngOnInit(): void {
    this.loadCourseRequests();
    this.initializeForm(); 
    this.handleBackButtonForModal();
   
  }

  private loadCourseRequests(): void {
    this.spinnerService.show();  // Start spinner
    this.apiService.getCourseRequests().subscribe({
      next: (data: any[]) => {
        this.customers = data;
      },
      error: (error: any) => {
        console.error('Error fetching course requests:', error);
        this.spinnerService.hide();  // Stop spinner on error
      },
      complete: () => {
        this.spinnerService.hide();  // Stop spinner on completion
      }
    });
  }

  private initializeForm(): void {
    this.mentorcourse = this.fb.group({
      course_name: ['', Validators.required],
      typeofcourse: ['Technical'],
      course_topic: ['', Validators.required],
      user_id: [this.user_id],
      course_des: [''],
      course_date: ['', Validators.required],
      course_time: ['', Validators.required],
      session_link: ['', Validators.required],
      comments: ['']
    });
  }

  //Form reset 
  Formreset() {
    this.mentorcourse.reset();
    this.initializeForm();
  }

  postdata() {
    if (this.mentorcourse.valid) {
      this.apiService.createMentorcourse(this.mentorcourse.value).subscribe(
        data => {
          Swal.fire({
            title: "Course has been created successfully!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: '#015792',
            iconColor: "#015792"
          }).then(() => {
            window.location.reload();
            this.Formreset();
          });
        },
        error => {
          console.log(error);
        }
      );
    }
  }

 getCurrentDates(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  handleBackButtonForModal() {
    // Push initial state to history
    history.pushState(null, '', window.location.href);
  
    window.onpopstate = () => {
      const modal = document.querySelector('.modal.show') as HTMLElement;
      if (modal) {
        // Find the close button inside the modal and trigger a click event on it
        const closeButton = modal.querySelector('.close') as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
  
        // Prevent default back navigation
        history.pushState(null, '', window.location.href);
      } else {
        // Allow back navigation as usual if modal is not open
        this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
      }
    };
  }
  ngOnDestroy(): void {
    // Cleanup event listener to avoid memory leaks
    window.onpopstate = null;
  }
}


